"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HubContext = exports.HubService = void 0;
const react_1 = __importDefault(require("react"));
class HubService {
    constructor(hubs) {
        this.hubs = hubs;
    }
    get(type) {
        const manager = this.hubs[type.id];
        if (manager && manager.isConnected) {
            return manager.hub;
        }
        return null;
    }
}
exports.HubService = HubService;
exports.HubContext = react_1.default.createContext(new HubService({}));
